import { Component, ElementRef, ViewChild } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
  
export class AppComponent {
  title = 'web';
  // @ViewChild('useThisTemplateVar') test: ElementRef<HTMLInputElement> = {} as ElementRef;

  ngAfterViewInit() {
    // console.log(this.test.nativeElement.className)
  }
}
